module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.d63782f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-LightItalic.ttf
// module id = 536
// module chunks = 0